




























































































































































































































































































































import Vue from "vue";
import _ from "lodash";
import BaseSimpleSlider from "@/app/shared/components/base/BaseSimpleSlider.vue";

export default Vue.extend({
  name: "FiltersController",
  components: { BaseSimpleSlider },
  data: function () {
    return {
      heightImage: "100%",
      filters: [
        {
          title: "Original",
          styleFilers: "none",
          adjustment: {
            brightness: 1,
            contrast: 1,
            saturation: 1,
            tint: 0,
            invert: 0,
            sepia: 0,
            glitch: null,
            sharpen: 0,
          },
        },
        {
          title: "Black & White",
          styleFilers: "contrast(2) saturate(0)",
          adjustment: {
            brightness: 1,
            contrast: 2,
            saturation: 0,
            tint: 0,
            invert: 0,
            sepia: 0,
            glitch: null,
            sharpen: 0,
          },
        },
        {
          title: "Brightness",
          styleFilers: "brightness(1.3)",
          adjustment: {
            brightness: 1.3,
            contrast: 1,
            saturation: 1,
            tint: 0,
            invert: 0,
            sepia: 0,
            glitch: null,
            sharpen: 0,
          },
        },
        {
          title: "Saturation",
          styleFilers: "saturate(2)",
          adjustment: {
            brightness: 1,
            contrast: 1,
            saturation: 2,
            tint: 0,
            invert: 0,
            sepia: 0,
            glitch: null,
            sharpen: 0,
          },
        },
        {
          title: "Invert",
          styleFilers: "invert(1)",
          adjustment: {
            brightness: 1,
            contrast: 1,
            saturation: 1,
            tint: 0,
            invert: 1,
            sepia: 0,
            glitch: null,
            sharpen: 0,
          },
        },
        {
          title: "Contrast",
          styleFilers: "brightness(1.1) contrast(1.5)",
          adjustment: {
            brightness: 1.1,
            contrast: 1.5,
            saturation: 1,
            tint: 0,
            invert: 0,
            sepia: 0,
            glitch: null,
            sharpen: 0,
          },
        },
        {
          title: "Sepia",
          styleFilers: "sepia(1)",
          adjustment: {
            brightness: 1,
            contrast: 1,
            saturation: 1,
            tint: 0,
            invert: 0,
            sepia: 1,
            glitch: null,
            sharpen: 0,
          },
        },
        {
          title: "Glitch",
          styleFilers: "none",
          adjustment: {
            brightness: 1,
            contrast: 1,
            saturation: 1,
            tint: 0,
            invert: 0,
            sepia: 0,
            glitch: 1.7,
            sharpen: 0,
          },
        },
      ],
    };
  },
  props: {
    isMultiSelectMode: {
      type: Boolean,
    },
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    currentVariationFilter: function () {
      return this.$store.state.selectedItem.currentVariation.filter;
    },
    intesity: {
      // getter
      get: function () {
        return this.$store.state.selectedItem.currentVariation.filter
          .presetIntensety;
      },
      // setter
      set: function (newValue) {
        this.$store.state.selectedItem.currentVariation.filter.presetIntensety =
          newValue;
      },
    },
    tab: function () {
      return this.$store.state.selectedItem.currentVariation.filter
        .currentPreset === "Custom"
        ? "adjustment"
        : "presets";
    },
    wasShownAndClosedNoticeSharpen: {
      // getter
      get: function () {
        return this.$store.getters.getWasShownAndClosedNoticeSharpen;
      },
      // setter
      set: function (wasShownAndClosedNoticeSharpen) {
        this.$store.commit(
          "setWasShownAndClosedNoticeSharpen",
          wasShownAndClosedNoticeSharpen
        );
      },
    },
  },
  watch: {
    previewItem: function () {
      this.checkAndUpdatePreviewItemThumbs();
    },
  },
  mounted() {
    this.checkAndUpdatePreviewItemThumbs();
  },
  methods: {
    resetNoticeSharpen() {
      this.wasShownAndClosedNoticeSharpen = true;
      this.items.forEach((i) => {
        i.variations.forEach((v) => {
          v.isShowNoticeSharpen = false;
        });
      });
    },
    changeTab(tabName) {
      if (tabName === "presets") {
        if (this.tab === "presets") {
          return;
        }
        this.currentVariationFilter.currentPreset = this.filters[0].title;
        this.currentVariationFilter.adjustment = {
          ...this.filters[0].adjustment,
        };
        this.changeCheckedItems();
        this.$forceUpdate();
        this.$store.commit("addNewStateToHistory");
      } else {
        this.resetNoticeSharpen();
        if (this.tab === "adjustment") {
          return;
        }
        this.currentVariationFilter.currentPreset = "Custom";
        this.currentVariationFilter.adjustment = {
          ...this.filters[0].adjustment,
        };
        this.changeCheckedItems();
        this.$forceUpdate();
        this.$store.commit("addNewStateToHistory");
      }
    },
    onClickFilter(filter) {
      this.currentVariationFilter.currentPreset = filter.title;
      this.currentVariationFilter.adjustment = _.cloneDeep(filter.adjustment);
      this.changeCheckedItems();
      this.$store.commit("addNewStateToHistory");
    },
    isActiveFilter(filterName) {
      return filterName === this.currentVariationFilter.currentPreset;
    },
    changeCheckedItems() {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }
      this.items.forEach((item) => {
        item.variations.forEach((v) => {
          if (!v.checked || v === this.previewItem.currentVariation) {
            return;
          }
          v.filter = _.cloneDeep(this.currentVariationFilter);
        });
      });
    },
    checkAndUpdatePreviewItemThumbs() {
      if (!this.previewItem || !this.previewItem.fileId) {
        setTimeout(() => {
          this.checkAndUpdatePreviewItemThumbs();
        }, 1000);
        return;
      }
      if (!this.previewItem.thumbs || this.previewItem.thumbs.length === 0) {
        this.axios
          .post(
            "/utils/getThumbs",
            {
              sessionId: this.$store.state.userInfo.sessionId,
              fileId: this.previewItem.fileId,
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            if (
              JSON.parse(response.config.data).fileId !==
              this.previewItem.fileId
            ) {
              this.checkAndUpdatePreviewItemThumbs();
              return;
            }
            this.previewItem.thumbs = response.data;
          });
      }
    },
  },
});
